<template>
  <section class="chat-wrapper">
    <div class="chat-members-wrapper">
      <div class="row chat-members-header">
        <div class="col">
          <div class="row chat-members-title">
            <div class="col-11">
              <span>Chat Session Members</span>
            </div>
            <div class="col-1">
              <div class="chat-close" @click="closeMembers"><i class="fas fa-times"></i></div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span>for {{ title }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row chat-members-content">
        <div class="col">
          <multiselect
            v-model="selected"
            id="searchMembers"
            label="label"
            track-by="guid"
            placeholder="invite a member (type to search)"
            open-direction="bottom"
            :options="foundMembers"
            class="w-100 multiselect__tags_add"
            :multiple="false"
            :max-height="500"
            :options-limit="100"
            :limit="5"
            :internal-search="false"
            :close-on-select="true"
            :show-no-results="false"
            :hide-selected="false"
            :loading="isLoading"
            @search-change="searchForMembers"
            @select="selectedMember"
          >
          </multiselect>
          <ul class="chat-members-list">
            <li v-for="item of currentMembers" :key="item.guid">
              <div class="row chat-members-record">
                <div class="col">
                  <span>{{ cleanName(item) }}</span>
                </div>
                <div class="col-1 chat-members-remove">
                  <a v-if="isNew || item.status === 'added'" href="#" @click="removeMember(item)" class="chat-remove" tabindex="-1">
                    <i class="fas fa-times text-danger"></i>
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <dt-message v-model="notice" :timeout="2000" class="alert alert-warning m-3" />
        </div>
      </div>
      <div class="row chat-members-footer">
        <div class="col chat-members-actions">
          <button v-if="isChanged" type="button" class="btn btn-danger btn-sm" @click="update()">
            Update
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import DtMessage from '@/components/utilities/form/dt-message'
export default {
  name: 'chat-members',
  components: {
    Multiselect,
    DtMessage
  },
  props: {
    channel: Object,
    isNew: {
      type: Boolean,
      value: false
    }
  },
  data() {
    return {
      isLoading: false,
      notice: null,
      selected: null,
      selectedMembers: [],
      foundMember: null
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('chat', ['channelInfo', 'foundMembers']),
    isVisible: {
      get() {
        return this.value
      }
    },
    title() {
      let _title = 'Chat'
      if (this.channelInfo) {
        if (this.channelInfo.type === 'adhoc') {
          _title = this.channelInfo.name
        } else {
          if (this.channelInfo.metadata) {
            if (Object.keys(this.channelInfo.metadata).length) {
              _title = `# ${this.channelInfo.name} - RO ${this.channelInfo.metadata.ronumber}`
            } else {
              _title = `${this.channelInfo.name}`
            }
          } else {
            _title = `${this.channelInfo.name}`
          }
        }
      }
      return _title
    },
    currentMembers() {
      let _members = []
      if (this.selectedMembers) {
        _members = this.selectedMembers
      }
      return _members
    },
    isChanged() {
      let _is = false
      if (this.selectedMembers) {
        let found = this.selectedMembers.find(x => x.status === 'added')
        if (found) {
          _is = true
        }
      }
      return _is
    },
    isOwner() {
      let _is = false
      if (this.channelInfo) {
        if (this.channelInfo.type.substring(0, 5) === 'adhoc' && this.channelInfo.owner !== null) {
          if (this.channelInfo.owner === this.profile.guid) {
            _is = true
          }
        }
      }
      return _is
    }
  },
  methods: {
    ...mapActions('chat', ['setChannelMembers', 'searchChatUsers', 'addMembers']),
    init() {
      this.selectedMembers = []
      if (this.channelInfo) {
        if (this.channelInfo) {
          if (this.channelInfo.members) {
            this.channelInfo.members.forEach(member => {
              this.selectedMembers.push({
                user: member.metadata.user,
                fileAs: member.name,
                email: member.metadata.email,
                name: member.name,
                guid: member.userId,
                status: member.connectionStatus,
                isActive: member.isActive
              })
            })
          }
        }
        console.log('Channel Members', this.selectedMembers)
      }
    },
    closeMembers() {
      this.$emit('closeMembers')
    },
    cleanName(item) {
      return `${item.name} (${item.email})`
    },
    searchForMembers: _.debounce(async function(search) {
      await this.fetchMembers(search)
    }, 350),
    async fetchMembers(search) {
      this.isLoading = true
      if (search.trim() !== '') {
        await this.searchChatUsers({
          firm: this.profile.firm,
          search: search
        })
        this.isLoading = false
      }
    },
    selectedMember() {
      this.$nextTick(() => {
        console.log('Selecting Member...', this.selected)
        this.isLoading = false
        if (this.selected && this.foundMembers) {
          let there = this.selectedMembers.find(x => x.guid === this.selected)
          if (!there) {
            let found = this.foundMembers.find(x => x.guid === this.selected.guid)
            console.log('Selected Member', {
              found: found,
              selected: this.selected,
              selectedMembers: this.selectedMembers
            })
            this.selectedMembers.push({
              label: found.label,
              user: found.user.toString(),
              fileAs: found.fileAs,
              email: found.username,
              name: found.name,
              guid: found.guid,
              status: 'added',
              isActive: true
            })
          }
          this.selected = null
          if (this.$refs.searchMembers) {
            this.$refs.searchMembers.clearSearch()
            this.$refs.searchMembers.clear()
          }
        }
      })
    },
    removeMember(item) {
      console.log('Remove Member', item)
      if (this.selectedMembers) {
        this.selectedMembers = this.selectedMembers.filter(x => x.guid !== item.guid)
      }
    },
    update() {
      this.notice = null
      if (this.selectedMembers.length > 0) {
        let guids = []
        this.selectedMembers.forEach(element => {
          guids.push(element.guid)
        })
        let found = this.selectedMembers.find(x => x === this.profile.guid)
        if (found === undefined || found === null) {
          guids.push(this.profile.guid)
        }
        // establish membership
        console.log('Updating Channel Membership', {
          channelInfo: this.channelInfo,
          members: guids,
          selectedMembers: this.selectedMembers
        })
        this.setChannelMembers({
          url: this.channelInfo.url,
          members: guids
        })
        // instead of a refresh of the current channel (ChannelInfo),
        // we'll just add the new members to its member list
        let newMembers = []
        this.selectedMembers.forEach(element => {
          let found = this.channelInfo.members.find(x => x.userId === element.guid)
          if (!found) {
            newMembers.push({
              connectionStatus: 'offline',
              isActive: true,
              lastSeenAt: -1,
              name: element.name,
              guid: element.guid,
              metadata: {
                email: element.email,
                firm: null,
                role: null,
                user: element.user
              }
            })
          }
        })
        console.log('Add Members', newMembers)
        this.addMembers(newMembers)
        this.$emit('updated')
      } else {
        this.notice = 'Please supply at least one recipient'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/elements/chat-members.vue